<!-- @format -->

<p class="empty-cart-title guidance">{{ "OPEN_UNIVERSITY_CART.WIZARD.TEACHING.EMPTY_CART" | translate }}</p>
<p class="guidance">{{ "OPEN_UNIVERSITY_CART.WIZARD.TEACHING.EMPTY_CART_GUIDANCE" | translate }}</p>
<a class="btn btn-primary btn-lg search-link-button anchor-button" uiSref="student.search.open-university">
  {{ "OPEN_UNIVERSITY_CART.WIZARD.TEACHING.SEARCH_COURSE_UNITS_BUTTON" | translate }}
</a>
